import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth"; // Import Firebase Auth
import { useParams } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import "./GameHistory.css";

const GameHistory = () => {
  const [userId, setUserId] = useState(null); // Dynamically track user ID
  const { theme } = useParams(); // Get theme from the URL
  const [history, setHistory] = useState([]); // Store game history

  useEffect(() => {
    const auth = getAuth();

    // Monitor authentication state
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid); // Set the authenticated user's ID
      } else {
        setUserId("guest_user"); // Default to guest_user if not logged in
      }
    });

    return () => unsubscribe(); // Cleanup listener on unmount
  }, []);

  useEffect(() => {
    if (!userId || userId === "guest_user") {
      return; // Skip fetching if the user is not logged in
    }

    const fetchGameHistory = async () => {
      try {
        // Reference the gameResults collection
        const resultsRef = collection(db, "users", userId, "gameResults");
        const snapshot = await getDocs(resultsRef);

        // Filter results by the theme from the URL
        const filteredResults = snapshot.docs
          .filter((doc) => doc.data().theme === theme) // Match the theme
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));

        console.log("Filtered results:", filteredResults); // Debugging
        setHistory(filteredResults);
      } catch (error) {
        console.error(`Error fetching history for ${theme}:`, error);
      }
    };

    fetchGameHistory();
  }, [userId, theme]);

  return (
    <div className="game-history-container">
      {userId === "guest_user" ? (
        // Prompt to sign in if the user is not authenticated
        <p>
          You must sign in to track your game history.{" "}
          <a href="/auth" className="sign-in-link">Sign In Now</a>
          </p>
      ) : (
        <>
          <h2 className="game-history-title">
            {theme?.charAt(0).toUpperCase() + theme?.slice(1)} Game History
          </h2>
          {history.length > 0 ? (
            <ul className="game-history-list">
              {history.map((result) => (
                <li key={result.id} className="game-history-item">
                  <p className="game-history-date">
                    Date: {new Date(result.date).toLocaleString()}
                  </p>
                  <p className="game-history-score">Score: {result.score}</p>
                  <p className="game-history-correct">
                    Correct Answers: {result.correctAnswers}
                  </p>
                  <p className="game-history-incorrect">
                    Incorrect Answers: {result.incorrectAnswers}
                  </p>
                </li>
              ))}
            </ul>
          ) : (
            <p>If you have played games, your history will appear here shortly.</p>
          )}
        </>
      )}
    </div>
  );
};

export default GameHistory;
